import type { Option as SelectOption } from 'src/@vymo/ui/atoms/select/types';

export type PlaybookTrackerSource = {
  type?: string;
  status?: string;
  clientId?: string;
  playbookCode?: string;
  executionId?: string;
  jobId?: string;
  ruleId?: string;
  ruleActionId?: string;
  recordId?: string;
  input?: unknown;
  createdAt?: number;
  updatedAt?: number;
  error?: string;
  env?: string;
  [key: string]: unknown;
};

export type PlaybookTrackerRow = PlaybookTrackerSource & {
  _id: string;
  _index?: string;
  _type?: string;
  _score?: number;
  createdAtLabel: string;
  updatedAtLabel: string;
};

export type PlaybookTrackerFilterOptions = {
  envs: string[];
  clients: string[];
  leadIds: string[];
  playbookCodes: string[];
  statuses: string[];
};

export const defaultPlaybookTrackerEnvs = ['staging', 'production'];

export type PlaybookTrackerFilters = {
  env: string;
  envLabel: string;
  clientId: string;
  recordId: string;
  playbookCode: string;
  status: string;
  dateRange: [Date | null, Date | null];
};

export type PlaybookTrackerSearchFilters = {
  host?: string;
  clientId?: string;
  recordId?: string;
  status?: string;
  playbookCode?: string;
  startDate?: Date;
  endDate?: Date;
};

export type PlaybookTrackerEsResponse = {
  hits?: {
    total?: {
      value?: number;
    };
    hits?: Array<{
      _id: string;
      _index?: string;
      _type?: string;
      _score?: number;
      _source?: PlaybookTrackerSource;
    }>;
  };
};

export type PlaybookTrackerSelectKey =
  | 'envLabel'
  | 'clientId'
  | 'recordId'
  | 'playbookCode';

export interface PlaybookTrackerState {
  loading: boolean;
  error: string | null;
  rows: PlaybookTrackerRow[];
  total: number;
  filterOptions: PlaybookTrackerFilterOptions;
}

export type DetailFieldConfig = {
  key: keyof PlaybookTrackerRow;
  label: string;
};

export type DetailSectionConfig = {
  title: string;
  fields: DetailFieldConfig[];
};

export type PlaybookTrackerResultRowProps = {
  row: PlaybookTrackerRow;
};

export type PlaybookTrackerFiltersProps = {
  filters: PlaybookTrackerFilters;
  loading: boolean;
  customEnvUrl: string;
  onInputChange: (key: PlaybookTrackerSelectKey) => (value: string) => void;
  onStatusChange: (values: SelectOption[]) => void;
  onStatusClearClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onDateRangeChange: (value: [Date, Date]) => void;
  onCustomEnvUrlChange: (value: string) => void;
  onCustomEnvAdd: () => void;
  onEnvSelect: (name: string, url: string) => void;
  onSearch: () => void;
  onReset: () => void;
};
